<template>

  <div>
  <el-dialog title="添加礼包" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="礼包名称" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: '请输入礼包名称'}]">
        <el-input v-model="form.name" placeholder="请输入等级名称"></el-input>
      </el-form-item>
      
      <el-form-item label="购买升级金额" :label-width="formLabelWidth" prop="money" >
        <el-input type="number"  min="0" v-model="form.money" placeholder="购买升级金额">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <el-form-item label="购买续费时长" :label-width="formLabelWidth" prop="time" >
        <el-input type="number"  min="0" v-model="form.time" placeholder="购买续费日期">
          <template slot="append">天</template>
        </el-input>
      </el-form-item>
      
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading">确 定</el-button>
    </div>
    
  </el-dialog>
    
   </div>
</template>

<script>

  import CardApi from '@/api/card.js';
  export default {
   
    data() {
      return {
        form: {
          /*名称*/
          name: '',
          /* 升级金额 */
          money:0,
          /* 升级时长 */
          time:0
          

        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,

        isproduct:0,
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {

      /*添加等级*/
      addGrade() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            CardApi.addGrade(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

       /*产品列表弹出层*/
      openProduct() {
        this.isproduct = true;
      },
      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.isproduct = e.openDialog;
        if (e.type == 'success') {
          if (this.form.upgrade_goods_id.indexOf(e.params.product_id) == -1) {
            this.form.upgrade_goods_id.push(e.params.product_id);
            this.form.product.push({ product_id: e.params.product_id, image: e.params.image,product_name: e.params.product_name });
          } else {
            this.$message({
              message: '已选择该商品',
              type: 'warning'
            });
          }
        }
      },
      /*删除商品*/
      deleteFunc(i) {
        this.form.upgrade_goods_id.splice(i, 1);
        this.form.product.splice(i, 1);
      },
    }
  };
</script>

<style>
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/cardauth/part/upgrade/Add.vue